import { FeedbackPositions } from 'utils/remote-config/properties';
import FeedbackWidget from 'components/Article/FeedbackWidget';

import FeedbackPopUpComponent from './components/FeedbackPopUp';
import FeedbackWidgetComponent from './components/FeedbackWidget';
import withFeedbackPositionExperiment from './hocs/withFeedbackPositionExperiment';

export const FeedbackPopUp = withFeedbackPositionExperiment(FeedbackPopUpComponent, [FeedbackPositions.POPUP]);

export const FeedbackStickyWidget = withFeedbackPositionExperiment(FeedbackWidgetComponent, [
  FeedbackPositions.STICKY,
  FeedbackPositions.POPUP,
]);

export const FeedbackCurrentWidget = withFeedbackPositionExperiment(FeedbackWidget, [FeedbackPositions.CURRENT]);
